module.exports = __webpack_public_path__ + "static/media/product-settings.b91b43ab.svg";